export function formatTimeInBarToMs(bar, resolution) {
  // console.log('方法', resolution, bar)
  const timezone = new Date().getTimezoneOffset() * 60 * 1000
  let mstime = 0
  if (resolution === '1D') {
    mstime = 57600000
  } else if (resolution === '1W') {
    mstime = 576000000
  } else if (resolution === '1M') {
    mstime = 2563200000
  }
  if (resolution === '1D' || resolution === '1W' || resolution === '1M') {
    return {
      ...bar,
      // time: bar.time,
      time: bar.time + mstime + timezone,
      // time2: bar.time * 1000 + mstime - timezone,
      // time3: bar.time * 1000,
      // time4: bar.time * 1000 + mstime
    }
  }
  return {
    ...bar,
  }
}
